import React, { Component } from 'react';
import { connect } from 'react-redux';
import $ from 'jquery';
import Moment from 'react-moment';
import capitalizarTodasPrimeirasLetras from '../../util/capitalizarTodasPrimeirasLetras';
import limparUltimosHistoricosPreco from '../../actions/preco/limparUltimosHistoricosPreco';
import { formatarReal } from '../../util/numberUtil';

export const Cabecalho = () => (
    <thead>
      <tr>
        <th>Data e Hora</th>
        <th>Situação</th>
        <th>Usuário</th>
        <th>Cidade Origem</th>
        <th>Cidade Destino</th>
        <th>Tipo Veículo</th>
        <th>Valor</th>
        <th>Valor ANTT</th>
        <th>Tarifa Seguro</th>
      </tr>
    </thead>
  );


export class ModalHistoricoPrecos extends Component {

    fecharModal () {
        $('#modalHistoricoPrecos').modal('hide');
        $('.modal-backdrop').remove();
        $('body').removeClass('modal-open');
        this.props.limparUltimosHistoricosPreco();
    }

    exibirHistoricos() {
        if (this.props.historicos && this.props.historicos.length) {
            return this.props.historicos.map(historico => (
              <tr key={`${historico.id}-${historico.dataEvento}`}>
                <td><Moment format="DD/MM/YYYY HH:mm">{historico.dataEvento}</Moment></td>
                <td>{capitalizarTodasPrimeirasLetras(historico.tipoEvento)}</td>
                <td>{capitalizarTodasPrimeirasLetras(historico.responsavel.nome)}</td>
                <td>{historico.preco.cidadeOrigem.nomeComUf}</td>
                <td>{historico.preco.cidadeDestino.nomeComUf}</td>
                <td>{historico.preco.descricaoTipoPreco
                  ? capitalizarTodasPrimeirasLetras(historico.preco.descricaoTipoPreco)
                  : capitalizarTodasPrimeirasLetras(historico.preco.tipoPreco)}</td>
                <td>{formatarReal(historico.preco.valor)}</td>
                <td>{formatarReal(historico.preco.valorAntt)}</td>
                <td>{historico.preco.tarifaSeguro ? formatarReal(historico.preco.tarifaSeguro) : '—'}</td>
              </tr>
            ))
          }
          return null
    }

    render() {
        return (
            <div className="modal fade show" id="modalHistoricoPrecos" role="dialog"
                aria-labelledby="modalHistoricoPrecos" aria-hidden="true" data-backdrop="static">
                <div className="modal-dialog modal-dialog-centered modal-xl">
                    <div className="modal-content" style={{ borderRadius: 12, overflow: 'hidden', border: 'none' }}>
                        <div className="vx-modal-header">
                            <div className="vx-modal-title">
                                <span className="material-icons">history</span>
                                Histórico Preços
                            </div>
                            <button type="button" className="vx-modal-close" data-dismiss="modal" aria-label="Close"
                                onClick={() => this.fecharModal()}>
                                <span className="material-icons">close</span>
                            </button>
                        </div>
                        <div className="vx-modal-body">
                            <div className="table-responsive">
                                <table className="table table-sm table-striped table-bordered" style={{ fontSize: 13 }}>
                                    <Cabecalho />
                                    <tbody>
                                        {this.exibirHistoricos()}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                        <div className="vx-modal-footer">
                            <button type="button" className="vx-modal-btn-fechar"
                                data-dismiss="modal" onClick={() => this.fecharModal()}>
                                Fechar
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        )
    }

}


export const mapStateToProps = (state) => {
    return {
        empresaSelecionada: state.empresaSelecionada,
        historicos: state.ultimosHistoricosPreco
    }
};

export default connect(mapStateToProps, {
    limparUltimosHistoricosPreco
})(ModalHistoricoPrecos)